module.exports = __webpack_public_path__ + "static/media/pudding.720e15ab.jpg";